<div class="jobseeker-language">
  <table>
    <tr>
      <td style="text-align: left; min-width: 84px">
        <button
          *ngIf="!isInEditMode"
          class="fa fa-times-circle btn btn-link"
          [disabled]="isInEditMode"
        ></button>
        <button
          *ngIf="!isInEditMode"
          class="fa fa-pencil btn btn-link"
          (click)="onEditLanguageClick()"
          [disabled]="isInEditMode"
        ></button>
      </td>
      <td style="min-width: 120px">
        <div *ngIf="!isInEditMode">{{ language?.worldLanguage?.name }}</div>
        <div *ngIf="isInEditMode">
          <select
            [disabled]="!isInAddMode"
            name="language"
            [ngModel]="
              language &&
              language.worldLanguage &&
              language.worldLanguage.worldLanguageId
            "
            (ngModelChange)="
              language &&
                language.worldLanguage &&
                (language.worldLanguage.worldLanguageId = $event)
            "
            convert-to-number
          >
            <option
              *ngFor="let item of worldLanguages"
              [value]="item.worldLanguageId"
              [selected]="
                item.worldLanguageId == language?.worldLanguage?.worldLanguageId
              "
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </td>
      <td style="min-width: 120px">
        <div *ngIf="!isInEditMode">
          {{ language?.languageProficiencyLevel?.name }}
        </div>
        <div *ngIf="isInEditMode">
          <select
            name="proficiencyLevel"
            [ngModel]="
              language &&
              language.languageProficiencyLevel &&
              language.languageProficiencyLevel.languageProficiencyLevelId
            "
            (ngModelChange)="
              language &&
                language.languageProficiencyLevel &&
                (language.languageProficiencyLevel.languageProficiencyLevelId =
                  $event)
            "
            convert-to-number
          >
            <option
              *ngFor="let item of languageproficiencyLevelList"
              [value]="item.value"
              [selected]="
                item.value ==
                language?.languageProficiencyLevel?.languageProficiencyLevelId
              "
            >
              {{ item.text }}
            </option>
          </select>
        </div>
      </td>
      <td>
        <div *ngIf="!isInEditMode">
          <form
            id="{{ 'langatchmt_' + language?.jobseekerLanguageId }}"
            action="{{ getDownloadUrl() }}"
            method="post"
            target="_blank"
          >
            <span *ngIf="language?.attachment != null">
              <a
                target="_blank"
                href="javascript:void(0)"
                (click)="
                  onDownloadLanguageAttachment(
                    'langatchmt_' + language?.jobseekerLanguageId
                  )
                "
                ><i class="fa fa-paperclip icon"></i>&nbsp;{{
                  'label.Certificate' | translate
                }}</a
              >
            </span>
          </form>
        </div>
      </td>
      <!--<td style="padding-left: 1em; padding-right: 2em;">
          <input *ngIf="isInEditMode" placeholder="{{'label.SelectFile' | translate}}" type="file" ngFileSelect [options]="uploadOptions" (onUpload)="handleUpload($event)">
        </td>-->
      <td style="padding-right: 0.5em">
        <button
          class="btn btn-default"
          *ngIf="isInEditMode"
          (click)="onSaveClick()"
          [disabled]="
            !language ||
            !language.worldLanguage?.worldLanguageId ||
            !language.languageProficiencyLevel?.languageProficiencyLevelId
          "
        >
          {{ 'label.Save' | translate }}
        </button>
      </td>
      <td>
        <button
          class="btn btn-default"
          *ngIf="isInEditMode"
          (click)="onCancelClick()"
        >
          {{ 'label.Cancel' | translate }}
        </button>
      </td>
    </tr>
  </table>
  <iframe
    name="hiddenFrame"
    style="position: absolute; top: -1px; left: -1px; width: 1px; height: 1px"
  ></iframe>
</div>
